export type EvcError = {
  message: string;
};

export type EvcApiError = {
  message: string;
  code: string;
  propertyName: string;
};

export type EvcFormErrorKey =
  | 'required'
  | 'unknown' // default error
  | 'length'
  | 'minLength'
  | 'maxLength'
  | 'pattern' // regex default error
  | 'validEmail'
  | 'validZipCode'
  | 'validPhone';

export enum ErrorTypes {
  UNKNOWN = 'unknown',
  /* front or 400 */
  INVALID = 'invalid',
  /* 422 */
  UNPROCESSABLE = 'unprocessable',
  /* 422 Conflict - TODO handle to suggest a reload */
  CONFLICT = 'conflict',
  /* 500 */
  INTERNAL = 'internal',
  /* 403 */
  FORBIDDEN = 'forbidden',
  /* 401 */
  UNAUTHORIZED = 'unauthorized',
}
export type ErrorType = `${ErrorTypes}`;
